import {
  BeneficialOwnerFormData,
  BeneficialOwnerPeopleValue,
  BeneficialOwnerValues
} from '../components/controlPersonInformationStep';
import { getControlPersonInfoSchema } from './getControlPersonInfoSchema';

export const handleControlPersonData = (
  values: BeneficialOwnerFormData
  //   helpers: FormikHelpers<BeneficialOwnerFormData> | undefined
) => {
  const arrangedPeople: BeneficialOwnerPeopleValue[] = [];
  const peopleId = values.peopleId;
  const valueEntries = Object.entries(values);
  peopleId.forEach((item) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const itemObj: any = {};
    valueEntries.forEach((valueObj) => {
      const doesIdExist = valueObj[0].includes(item);
      if (doesIdExist) {
        const slicedValueKey = valueObj[0].split('-');
        itemObj[slicedValueKey[0]] = valueObj[1];
      }
    });

    arrangedPeople.push({ [item]: itemObj });
  });

  return arrangedPeople;
};

export const handleValidateControlPersonData = async (values: BeneficialOwnerFormData) => {
  const arrangedPeople = handleControlPersonData(values);
  let fullErrorObj: Record<string, string> | undefined = undefined;
  const fullTouchedObj: Record<string, boolean> = {};

  const validationPromises = arrangedPeople.map(async (person) => {
    const [personData] = Object.entries(person);
    const { errObj } = await handleCheckBeneficialOwnerData(personData);
    return errObj;
  });

  const errorObjects = await Promise.all(validationPromises);

  errorObjects.forEach((errObj) => {
    if (typeof errObj !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const errObjKey = Object.keys(errObj as any);
      errObjKey.forEach((key) => {
        fullTouchedObj[key] = true;
      });
      fullErrorObj = { ...fullErrorObj, ...errObj };
    }
  });

  return { fullErrorObj, fullTouchedObj, arrangedPeople };
};

const handleCheckBeneficialOwnerData = async (personData: [string, BeneficialOwnerValues]) => {
  const [key, value] = personData;
  try {
    await getControlPersonInfoSchema(value).validate(value, { abortEarly: false });

    return { errObj: undefined };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    const errorArray = error.inner;
    const errObj: Record<string, string> = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    errorArray.forEach((err: any) => {
      const fieldName = `${err.path}-${key}`;
      errObj[fieldName] = err.message;
    });

    return { errObj };
  }
};
